export default "__VITE_ASSET__9fa84910__"